"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAvatar = _interopRequireDefault(require("react-avatar"));

var _Avatar = require("./Avatar.style");

var _excluded = ["size"];
var sizeMap = {
  s: 32,
  m: 40,
  l: 48
};

var Avatar = function Avatar(_ref) {
  var size = _ref.size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var avatarSize = size;
  if (typeof size === 'string' && Object.keys(sizeMap).includes(size)) avatarSize = sizeMap[size];
  return /*#__PURE__*/_react["default"].createElement(_Avatar.StyledAV, null, /*#__PURE__*/_react["default"].createElement(_reactAvatar["default"], (0, _extends2["default"])({
    size: avatarSize
  }, props)));
};

Avatar.defaultProps = {
  size: 'm',
  round: true
};
Avatar.propTypes = {
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['s', 'm', 'l'])]),
  name: _propTypes["default"].string,
  src: _propTypes["default"].string,
  round: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string, _propTypes["default"].number])
};
var _default = Avatar;
exports["default"] = _default;